<template>
    <v-alert
        v-if="isVisible"
        :type="type"
        :text="text"
        :outlined="outlined"
        :dense="dense"
        :icon="icon"
        :dismissible="dismissible"
        :class="classes"
    >
        <slot>
            {{ message }}
        </slot>
    </v-alert>
</template>

<script>
import { hasActiveFilters } from '@utils/filters'

export default {
    name: 'ActiveFiltersAlert',

    props: {
        filters: {
            type: [Object, Array],
            required: true,
        },
        message: {
            type: String,
            default: 'Filtros aplicados',
        },
        type: {
            type: String,
            default: 'info',
        },
        text: {
            type: Boolean,
            default: true,
        },
        outlined: {
            type: Boolean,
            default: false,
        },
        dense: {
            type: Boolean,
            default: false,
        },
        icon: {
            type: String,
            default: undefined,
        },
        dismissible: {
            type: Boolean,
            default: false,
        },
        classes: {
            type: [String, Array, Object],
            default: 'mb-2 mt-2',
        },
    },

    computed: {
        isVisible() {
            return hasActiveFilters(this.filters)
        },
    },
}
</script>


